import React, { useState, useEffect } from 'react';
import Inspector from './Inspector';
import { fetchData } from '../services/dataService';

const InspectorList = ({ list }) => {

    return (
        <div>

            <div style={{
                display: "flex", justifyContent: "space-between", width: "100%"
            }}>
                <div style={{ display: 'flex', paddingTop: "10px", width: "100%" }}>
                    {list != null && list.length > 0 ? (
                        list.map((item, index) => (
                            <React.Fragment key={index}>
                                <div style={{width: "100px"}}>
                                    <Inspector data={item} />
                                </div>
                            </React.Fragment>
                        ))
                    ) : (
                        <p>Загрузка данных...</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default InspectorList;